<template>
    <div class="general-input d-flex flex-column">
        <label v-if="label" class="input-label mb-1" :class="lightLabel ? 'light' : ''">
            {{ label }}
        </label>

        <textarea v-if="inputType == 'textarea'"
            :disabled="disabled"
            :class="error ? 'error' : ''"
            :placeholder="placeholder"
            :type="inputType"
            :value="value"
            @input="$emit('input', $event.target.value)"
            @change="$emit('onChange', $event)"
        />

        <input
            v-else
            :disabled="disabled"
            :class="error ? 'error' : ''"
            :placeholder="placeholder"
            :type="inputType"
            :value="value"
            @input="$emit('input', $event.target.value)"
            @change="$emit('onChange', $event)"
        />
        <small class="error-message" v-if="error">{{ error }}</small>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
        }
    },
    props: {
        value: {
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        classes: {
            type: String,
        },
        label: {
            type: String,
            default: '',
        },
        lightLabel: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            default: 'Input placeholder',
        },
        inputType: {
            type: String,
            default: 'text',
        },
        error: {
            type: String,
        }
    }
}
</script>

<style lang='scss'>
.general-input {
    label {
        color: black;
        font-size: 1rem;
        font-weight: 600;
        display: inline-block;

        &.light {
            font-weight: 500;
        }
    }

    input, textarea {
        background: white;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 5px;
        padding: 0.5rem 0.5rem;
        font-size: 14px;
        font-weight: 400;
        width: 100%;
        min-height: 43px;

        &.error {
            border-color: #B43927;
        }

        &::placeholder {
            color: darken(#adadad, 25%);
        }
    }

    textarea {
        flex: 1;
    }
    
    .error-message {
        padding-top: 0.25rem;
        color: #B43927;
    }
}
</style>



// WEBPACK FOOTER //
// GeneralInput.vue?3cc40a6e